// Timezones offered on the mentor session picker: the same set SYNC understands, so a booking made
// here can be handed to SYNC without translation. `value` is what is sent to the API; the label
// carries the abbreviations people actually type and say. Keep in step with SUPPORTED_TIMEZONES in
// backend/app/services/mentor_booking_service.py (the server rejects anything else).
export const TIMEZONE_OPTIONS = [
  { value: 'Asia/Kolkata', label: 'India (IST)' },
  { value: 'America/Los_Angeles', label: 'US Pacific (PST/PDT)' },
  { value: 'America/New_York', label: 'US Eastern (EST/EDT)' },
  { value: 'America/Chicago', label: 'US Central (CST/CDT)' },
  { value: 'America/Denver', label: 'US Mountain (MST/MDT)' },
  { value: 'GMT', label: 'Greenwich Mean Time (GMT, no daylight saving)' },
  { value: 'UTC', label: 'Coordinated Universal Time (UTC)' },
  { value: 'Europe/London', label: 'UK / London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Central Europe (CET/CEST)' },
  { value: 'Europe/Athens', label: 'Eastern Europe (EET/EEST)' },
  { value: 'Asia/Tokyo', label: 'Japan (JST)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)' },
  { value: 'Australia/Perth', label: 'Perth (AWST)' },
  { value: 'Pacific/Auckland', label: 'New Zealand (NZST/NZDT)' },
  { value: 'Asia/Karachi', label: 'Pakistan (PKT)' },
  { value: 'Asia/Dubai', label: 'Gulf / UAE (GST)' },
  { value: 'Asia/Singapore', label: 'Singapore (SGT)' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)' }
];

export const SUPPORTED_TIMEZONES = TIMEZONE_OPTIONS.map((option) => option.value);

const FALLBACK_TIMEZONE = 'Asia/Kolkata';

// Names a browser may report for a zone that is on the list under another name.
const ALIASES = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Etc/UTC': 'UTC',
  'Etc/GMT': 'GMT',
  'Etc/Greenwich': 'GMT',
  'Europe/Belfast': 'Europe/London',
  'Asia/Muscat': 'Asia/Dubai'
};

// Students have no saved timezone yet, so: the browser's if it is on the list, else IST. A browser
// in an unlisted zone (Asia/Kathmandu, say) starts on IST and the student can switch.
export const getDefaultTimezone = () => {
  try {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const name = ALIASES[detected] || detected;
    return SUPPORTED_TIMEZONES.includes(name) ? name : FALLBACK_TIMEZONE;
  } catch (e) {
    return FALLBACK_TIMEZONE;
  }
};

export const getTimezoneOptions = () => TIMEZONE_OPTIONS;

export const getTimezoneLabel = (value) => (
  TIMEZONE_OPTIONS.find((option) => option.value === value)?.label || value
);
